import React, {createRef} from 'react';
import {observable, action, makeObservable, computed} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';
import * as util from '../../util';
import {PCS_CSS} from '../i';
import * as emitter from '../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../global/store/ab-test.store';
import {linoGirlScoutsAutographStore} from '../components/lino/lino-girl-scouts-autograph/lino-girl-scouts-autograph.store';

declare var __portal: IPortalSettings;

interface IProductRenderProps {
    css: PCS_CSS;
    zoom: boolean;
}

@observer
export default class ProductRender extends React.Component<IProductRenderProps> {
    @observable isZoomVisible: boolean = false;
    @observable originalContainerRef: React.RefObject<HTMLDivElement> = createRef();
    @observable zoomedContainerRef: React.RefObject<HTMLDivElement> = createRef();
    @observable zoomSquareContainerRef: React.RefObject<HTMLDivElement> = createRef();

    constructor(props: IProductRenderProps) {
        super(props);
        this.isZoomVisible = false;
        makeObservable(this);
    }

    componentDidMount(): void {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
        var loadingDiv = document.getElementById('prod-loading') as HTMLDivElement;
        if (loadingDiv) {
            loadingDiv.remove();
        }
    }

    @computed get getADA() {
        if (!s.si && !s.prod) {
            return 'Diploma Frame';
        }

        let ada = `${s.si ? s.si.InstName : ''} ${s.PortalID < 1 ? `Diploma` : `Document`} Frame`;
        if (s.pcs.moulding_id > 0) {
            ada += ` in ${s.ui.title_moulding}`;
        }


        if (!s.prod.IsFrame) {
            ada = s.prod.Name;
        } else if (s.prod.CustomizationMethod < 2) {
            if (s.prod.Mat1_ID > 0) {
                ada += ` with ${s.prod.MatComboName} matting`;
            }

            if (s.prod.InsigniaID > 0) {
                ada += `, and a ${s.prod.InsigniaDisplayName}`;
            }
            ada += '.';
        } else {
            if (s.pcs.mat1_id > 0 || s.pcs.mat2_id > 0) {
                ada += ` with ${s.ui.title_mat_combo} matting`;
            }

            if (s.pcs.insignia_id > 0) {
                ada += `, and a ${s.ui.title_insignia ? s.ui.title_insignia : s.prod.InsigniaDisplayName}`;
            }
            ada += '.';
        }
        return ada.trim();
    }

    @action
    onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const squareCurrent = this.zoomSquareContainerRef.current;
        const originalCurrent = this.originalContainerRef.current;

        if (!originalCurrent || !squareCurrent) return;

        this.calculateZoomSquareSize();

        const imageRect = originalCurrent.getBoundingClientRect();
        const squareWidth = parseInt(squareCurrent.style.width, 10);
        const squareHeight = parseInt(squareCurrent.style.height, 10);

        

        let mouseX = e.clientX - imageRect.left;
        let mouseY = e.clientY - imageRect.top;

        mouseX -= squareWidth / 2;
        mouseY -= squareHeight / 2;

        if (mouseX + squareWidth > imageRect.width) mouseX = imageRect.width - squareWidth;

        if (mouseY + squareHeight > imageRect.height) mouseY = imageRect.height - squareHeight;

        if (mouseX < 0) mouseX = 0;

        if (mouseY < 0) mouseY = 0;

        squareCurrent.style.top = `${mouseY}px`;
        squareCurrent.style.left = `${mouseX}px`;

        const scale = 2;

        this.setStyle('transformOrigin', `${mouseX * scale}px ${mouseY * scale}px`);
        this.setStyle('transform', `scale(${scale})`);
        this.setStyle('width', `${squareWidth * scale}px`, true);
        this.setStyle('height', `${squareHeight * scale}px`, true);
        this.setStyle('border', '1px solid gray', true);
        this.setStyle('boxShadow', '0 0 7px 5px rgba(0, 0, 0, .75)', true);
    };

    @action
    calculateZoomSquareSize = () => {
        const current = this.zoomSquareContainerRef.current;

        if (!current) return;

        let squareWidth: number;
        let squareHeight: number;

        const {frame_display_width, frame_display_height} = this.props.css;
        const ratio = frame_display_width / frame_display_height;

        if (frame_display_width > frame_display_height) {
            squareWidth = 350;
            squareHeight = squareWidth / ratio;
        } else {
            squareHeight = 350;
            squareWidth = squareHeight * ratio;
        }

        current.style.width = `${squareWidth}px`;
        current.style.height = `${squareHeight}px`;
    };

    @action
    onMouseLeave = () => {
        this.isZoomVisible = false;
    };

    @action
    onMouseEnter = () => {
        if (window.innerWidth > 1200) {
            this.isZoomVisible = true;
        }
    };

    @action
    setStyle(attr: string, value: string, parentStyle: boolean = false) {
        const current = this.zoomedContainerRef.current;

        if (!current) return;

        if (parentStyle && current.parentElement) {
            current.parentElement.style[attr] = value;
        } else {
            current.style[attr] = value;
        }
    }

    @action
    save = async (e: any) => {
        // const w:number = s.pcs.css.frame_display_width;
        // const h:number = s.pcs.css.frame_display_height;
        // const ratio:number = w/h;
        // console.log(w, h, ratio);
        // const newWidth:number = 565;
    };

    abForceUpdate = async () => this.forceUpdate();

    render() {
        if (!s.ready || !this.props.css) {
            return;
        }

        let replaceImage: boolean;
        let newImage: React.JSX.Element;

        const th6Enabled = !s.prod.th6Disabled && !util.isNullOrWhiteSpace(s.prod.th6);

        if (th6Enabled) {
            const defaultConfiguration = s.prod.MouldingID === s.pcs.moulding_id && s.prod.Mat1_ID === s.pcs.mat1_id && s.prod.Mat2_ID === s.pcs.mat2_id && s.prod.InsigniaID === s.pcs.insignia_id && s.prod.EngravedPlateStatusID === s.pcs.ep_id && s.prod.LinoID === s.pcs.lino_id;

            replaceImage = defaultConfiguration && th6Enabled && AbTestStore.ABIsVariant(ABTestKeys.ab_prod_th6, 1);
            newImage = (
                <img
                    id="frame-none"
                    className="img-core"
                    src={`https://${s.Portal.CDNDomain}${s.prod.th6}_1440.jpg`}
                    alt={`Product Image of ${s.prod.Name}`}
                    style={{width: '100%', height: '100%', objectFit: 'contain'}}
                />
            );
        }

        const renderContent = () => {
            if (s.prod.CustomizationMethod < 1) {
                return (
                    <div id="frame-none-container">
                        <div id="frame-none-container-inner">
                            {!replaceImage && (
                                <img
                                    id="frame-none"
                                    className="img-core"
                                    src={s.prod.ProductID === 88937 ? linoGirlScoutsAutographStore.productImageUrl : `https://${s.Portal.CDNDomain}/images/products/full/${s.prod.Image_Full.toLowerCase()}`}
                                    alt={`Product Image of ${s.prod.Name}`}
                                />
                            )}

                            {replaceImage && newImage}

                            {s.prod && s.prod.is_tassel_cord && (
                                <div className="tassel-cord tassel-cord-0">
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.webp`}
                                        />
                                        <img
                                            width="128"
                                            height="128"
                                            src={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.png`}
                                            alt="Frame Also Holds Cord"
                                            loading="lazy"
                                        />
                                    </picture>
                                </div>
                            )}
                        </div>
                    </div>
                );
            }

            if (s.prod.CustomizationMethod === 1) {
                return (
                    <div
                        id="frame-old-container"
                        style={{padding: `${this.props.css.moulding_half}px 0`}}
                        role="img"
                        aria-label={this.getADA}
                    >
                        {!replaceImage && (
                            <div id="frame-old-container-inner">
                                <img
                                    id="frame-old"
                                    className="img-core"
                                    src={s.ui.old_style_composite.includes('oldstyle') ? `https://${s.Portal.CDNDomain}/images/products/composites/${s.ui.old_style_composite}` : `https://${s.Portal.CDNDomain}/images/products/composites/primary/${s.ui.old_style_composite}`}
                                    alt={`Product Image of ${s.prod.Name}`}
                                />
                                <img
                                    id="m_topleft"
                                    className="old-moulding z4"
                                    alt=""
                                    src={this.props.css.m_topleft_src}
                                    style={{
                                        left: `-${this.props.css.moulding_half}px`,
                                        top: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_topleft_width,
                                    }}
                                />
                                <img
                                    id="m_topright"
                                    className="old-moulding z4"
                                    alt=""
                                    src={this.props.css.m_topright_src}
                                    style={{
                                        right: `-${this.props.css.moulding_half}px`,
                                        top: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_topright_width,
                                    }}
                                />
                                <img
                                    id="m_bottomright"
                                    className="old-moulding z4"
                                    alt=""
                                    src={this.props.css.m_bottomright_src}
                                    style={{
                                        right: `-${this.props.css.moulding_half}px`,
                                        bottom: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_bottomright_width,
                                    }}
                                />
                                <img
                                    id="m_bottomleft"
                                    className="old-moulding z4"
                                    alt=""
                                    src={this.props.css.m_bottomleft_src}
                                    style={{
                                        left: `-${this.props.css.moulding_half}px`,
                                        bottom: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_bottomleft_width,
                                    }}
                                />
                                <img
                                    id="m_left"
                                    className="old-moulding z3"
                                    alt=""
                                    src={this.props.css.m_left_src}
                                    style={{
                                        left: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_left_width,
                                        height: this.props.css.m_left_height,
                                    }}
                                />
                                <img
                                    id="m_top"
                                    className="old-moulding z3 w100"
                                    alt=""
                                    src={this.props.css.m_top_src}
                                    style={{
                                        top: `-${this.props.css.moulding_half}px`,
                                        left: 0,
                                        width: this.props.css.m_top_width,
                                        height: this.props.css.m_top_height,
                                    }}
                                />
                                <img
                                    id="m_right"
                                    className="old-moulding z3"
                                    alt=""
                                    src={this.props.css.m_right_src}
                                    style={{
                                        right: `-${this.props.css.moulding_half}px`,
                                        width: this.props.css.m_right_width,
                                        height: this.props.css.m_right_height,
                                    }}
                                />
                                <img
                                    id="m_bottom"
                                    className="old-moulding z3 w100"
                                    alt=""
                                    src={this.props.css.m_bottom_src}
                                    style={{
                                        bottom: `-${this.props.css.moulding_half}px`,
                                        left: 0,
                                        width: this.props.css.m_bottom_width,
                                        height: this.props.css.m_bottom_height,
                                    }}
                                />
                                {s.prod && s.prod.is_tassel_cord && (
                                    <div className="tassel-cord tassel-cord-1">
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.webp`}
                                            />
                                            <img
                                                width="128"
                                                height="128"
                                                src={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.png`}
                                                alt="Frame Also Holds Cord"
                                                loading="lazy"
                                            />
                                        </picture>
                                    </div>
                                )}
                            </div>
                        )}

                        {replaceImage && newImage}
                    </div>
                );
            } else {
                return (
                    <div
                        id="frame-outer"
                        role="img"
                        aria-label={this.getADA}
                    >
                        <div
                            id="frame-helper"
                            style={{
                                width: `${this.props.css.frame_display_width}px`,
                                height: `${this.props.css.frame_display_height}px`,
                            }}
                        />

                        {s.pcs.moulding_id === 14631 && (
                            <div
                                style={{
                                    width: `${parseInt(this.props.css.m_topleft_width.replace('px', ''), 10) * 2 + parseInt(this.props.css.m_top_width.replace('px', ''))}px`,
                                    height: `${parseInt(this.props.css.m_topleft_width.replace('px', ''), 10) * 2 + parseInt(this.props.css.m_left_height.replace('px', ''))}px`,
                                    boxShadow: 'rgb(180, 180, 180) 6px 6px 10px',
                                    margin: '0 auto',
                                    position: 'absolute',
                                    top: 0,
                                }}
                            ></div>
                        )}

                        <div
                            id="frame-display"
                            style={{
                                height: `${this.props.css.frame_display_height}px`,
                                width: `${this.props.css.frame_display_width}px`,
                            }}
                            onClick={this.save}
                        >
                            {!replaceImage && (
                                <div
                                    id="frame-container"
                                    style={{
                                        backgroundImage: `url("${this.props.css.pmat_BackgroundImage}")`,
                                        width: this.props.css.pmat_width,
                                        height: this.props.css.pmat_height,
                                        backgroundSize: this.props.css.pmat_backgroundSize,
                                        top: this.props.css.pmat_top,
                                    }}
                                >
                                    {/* Moulding */}
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_topleft_src)}
                                        />
                                        <img
                                            id="m_topleft"
                                            alt=""
                                            src={this.props.css.m_topleft_src}
                                            style={{
                                                left: this.props.css.m_topleft_left,
                                                top: this.props.css.m_topleft_top,
                                                width: this.props.css.m_topleft_width,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_topright_src)}
                                        />
                                        <img
                                            id="m_topright"
                                            alt=""
                                            src={this.props.css.m_topright_src}
                                            style={{
                                                left: this.props.css.m_topright_left,
                                                top: this.props.css.m_topright_top,
                                                width: this.props.css.m_topright_width,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_bottomright_src)}
                                        />
                                        <img
                                            id="m_bottomright"
                                            alt=""
                                            src={this.props.css.m_bottomright_src}
                                            style={{
                                                left: this.props.css.m_bottomright_left,
                                                top: this.props.css.m_bottomright_top,
                                                width: this.props.css.m_bottomright_width,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_bottomleft_src)}
                                        />
                                        <img
                                            id="m_bottomleft"
                                            alt=""
                                            src={this.props.css.m_bottomleft_src}
                                            style={{
                                                left: this.props.css.m_bottomleft_left,
                                                top: this.props.css.m_bottomleft_top,
                                                width: this.props.css.m_bottomleft_width,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_left_src)}
                                        />
                                        <img
                                            id="m_left"
                                            alt=""
                                            src={this.props.css.m_left_src}
                                            style={{
                                                left: this.props.css.m_left_left,
                                                top: this.props.css.m_left_top,
                                                width: this.props.css.m_left_width,
                                                height: this.props.css.m_left_height,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_top_src)}
                                        />
                                        <img
                                            id="m_top"
                                            alt=""
                                            src={this.props.css.m_top_src}
                                            style={{
                                                left: this.props.css.m_top_left,
                                                top: this.props.css.m_top_top,
                                                width: this.props.css.m_top_width,
                                                height: this.props.css.m_top_height,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_right_src)}
                                        />
                                        <img
                                            id="m_right"
                                            alt=""
                                            src={this.props.css.m_right_src}
                                            style={{
                                                left: this.props.css.m_right_left,
                                                top: this.props.css.m_right_top,
                                                width: this.props.css.m_right_width,
                                                height: this.props.css.m_right_height,
                                            }}
                                        />
                                    </picture>

                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet={util.webp(this.props.css.m_bottom_src)}
                                        />
                                        <img
                                            id="m_bottom"
                                            alt=""
                                            src={this.props.css.m_bottom_src}
                                            style={{
                                                left: this.props.css.m_bottom_left,
                                                top: this.props.css.m_bottom_top,
                                                width: this.props.css.m_bottom_width,
                                                height: this.props.css.m_bottom_height,
                                            }}
                                        />
                                    </picture>

                                    {this.props.css.doc1_visible && (
                                        <div
                                            id="doc1_pmat_bevel"
                                            style={{
                                                backgroundColor: this.props.css.doc1_pmat_bevel_backgroundColor,
                                                left: this.props.css.doc1_pmat_bevel_left,
                                                top: this.props.css.doc1_pmat_bevel_top,
                                                width: this.props.css.doc1_pmat_bevel_width,
                                                height: this.props.css.doc1_pmat_bevel_height,
                                            }}
                                        >
                                            <div
                                                id="doc1_smat"
                                                style={{
                                                    backgroundColor: this.props.css.doc1_smat_backgroundColor,
                                                    left: this.props.css.doc1_smat_left,
                                                    top: this.props.css.doc1_smat_top,
                                                    width: this.props.css.doc1_smat_width,
                                                    height: this.props.css.doc1_smat_height,
                                                }}
                                            >
                                                <div
                                                    id="doc1_smat_bevel"
                                                    style={{
                                                        backgroundColor: this.props.css.doc1_smat_bevel_backgroundColor,
                                                        left: this.props.css.doc1_smat_bevel_left,
                                                        top: this.props.css.doc1_smat_bevel_top,
                                                        width: this.props.css.doc1_smat_bevel_width,
                                                        height: this.props.css.doc1_smat_bevel_height,
                                                    }}
                                                >
                                                    <picture>
                                                        {!s.ui.image_uploaded && (
                                                            <source
                                                                type="image/webp"
                                                                srcSet={util.webp(this.props.zoom ? this.props.css.doc1_src.replace('_350', '_original') : this.props.css.doc1_src)}
                                                            />
                                                        )}
                                                        <img
                                                            id="doc1"
                                                            style={{
                                                                left: this.props.css.doc1_left,
                                                                top: this.props.css.doc1_top,
                                                                width: this.props.css.doc1_width,
                                                                height: this.props.css.doc1_height,
                                                            }}
                                                            src={this.props.zoom ? this.props.css.doc1_src.replace('_350', '_original') : this.props.css.doc1_src}
                                                            alt=""
                                                        />
                                                    </picture>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.props.css.doc2_visible && (
                                        <div
                                            id="doc2_pmat_bevel"
                                            style={{
                                                backgroundColor: this.props.css.doc2_pmat_bevel_backgroundColor,
                                                left: this.props.css.doc2_pmat_bevel_left,
                                                top: this.props.css.doc2_pmat_bevel_top,
                                                width: this.props.css.doc2_pmat_bevel_width,
                                                height: this.props.css.doc2_pmat_bevel_height,
                                            }}
                                        >
                                            <div
                                                id="doc2_smat"
                                                style={{
                                                    backgroundColor: this.props.css.doc2_smat_backgroundColor,
                                                    left: this.props.css.doc2_smat_left,
                                                    top: this.props.css.doc2_smat_top,
                                                    width: this.props.css.doc2_smat_width,
                                                    height: this.props.css.doc2_smat_height,
                                                }}
                                            >
                                                <div
                                                    id="doc2_smat_bevel"
                                                    style={{
                                                        backgroundColor: this.props.css.doc2_smat_bevel_backgroundColor,
                                                        left: this.props.css.doc2_smat_bevel_left,
                                                        top: this.props.css.doc2_smat_bevel_top,
                                                        width: this.props.css.doc2_smat_bevel_width,
                                                        height: this.props.css.doc2_smat_bevel_height,
                                                    }}
                                                >
                                                    <img
                                                        id="doc2"
                                                        loading="lazy"
                                                        style={{
                                                            left: this.props.css.doc2_left,
                                                            top: this.props.css.doc2_top,
                                                            width: this.props.css.doc2_width,
                                                            height: this.props.css.doc2_height,
                                                        }}
                                                        src={this.props.zoom ? this.props.css.doc2_src.replace('_350', '_original') : this.props.css.doc2_src}
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.props.css.tassel_visible && (
                                        <div
                                            id="tassel_pmat_bevel"
                                            style={{
                                                left: this.props.css.tassel_pmat_bevel_left,
                                                top: this.props.css.tassel_pmat_bevel_top,
                                                width: this.props.css.tassel_pmat_bevel_width,
                                                height: this.props.css.tassel_pmat_bevel_height,
                                                backgroundColor: this.props.css.tassel_pmat_bevel_backgroundColor,
                                            }}
                                        >
                                            <div
                                                id="tassel_smat"
                                                style={{
                                                    left: this.props.css.tassel_smat_left,
                                                    top: this.props.css.tassel_smat_top,
                                                    width: this.props.css.tassel_smat_width,
                                                    height: this.props.css.tassel_smat_height,
                                                    backgroundColor: this.props.css.tassel_smat_backgroundColor,
                                                }}
                                            >
                                                <div
                                                    id="tassel_smat_bevel"
                                                    style={{
                                                        left: this.props.css.tassel_smat_bevel_left,
                                                        top: this.props.css.tassel_smat_bevel_top,
                                                        width: this.props.css.tassel_smat_bevel_width,
                                                        height: this.props.css.tassel_smat_bevel_height,
                                                        backgroundColor: this.props.css.tassel_smat_bevel_backgroundColor,
                                                    }}
                                                >
                                                    <img
                                                        id="tassel"
                                                        style={{
                                                            left: this.props.css.tassel_left,
                                                            top: this.props.css.tassel_top,
                                                            width: this.props.css.tassel_width,
                                                            height: this.props.css.tassel_height,
                                                        }}
                                                        src={this.props.css.tassel_src}
                                                        alt=""
                                                    />
                                                    <div
                                                        style={{
                                                            boxShadow: 'inset 0 0px 4px #000',
                                                            left: this.props.css.tassel_left,
                                                            top: this.props.css.tassel_top,
                                                            width: this.props.css.tassel_width,
                                                            height: this.props.css.tassel_height,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.props.css.fillet_visible && (
                                        <div
                                            id="f_container"
                                            style={{
                                                left: this.props.css.f_container_left,
                                                top: this.props.css.f_container_top,
                                                width: this.props.css.f_container_width,
                                                height: this.props.css.f_container_height,
                                            }}
                                        >
                                            <img
                                                id="f_topleft"
                                                alt=""
                                                src={this.props.css.f_topleft_src}
                                                style={{
                                                    left: this.props.css.f_topleft_left,
                                                    top: this.props.css.f_topleft_top,
                                                    width: this.props.css.f_topleft_width,
                                                }}
                                            />
                                            <img
                                                id="f_topright"
                                                alt=""
                                                src={this.props.css.f_topright_src}
                                                style={{
                                                    left: this.props.css.f_topright_left,
                                                    top: this.props.css.f_topright_top,
                                                    width: this.props.css.f_topright_width,
                                                }}
                                            />
                                            <img
                                                id="f_bottomright"
                                                alt=""
                                                src={this.props.css.f_bottomright_src}
                                                style={{
                                                    left: this.props.css.f_bottomright_left,
                                                    top: this.props.css.f_bottomright_top,
                                                    width: this.props.css.f_bottomright_width,
                                                }}
                                            />
                                            <img
                                                id="f_bottomleft"
                                                alt=""
                                                src={this.props.css.f_bottomleft_src}
                                                style={{
                                                    left: this.props.css.f_bottomleft_left,
                                                    top: this.props.css.f_bottomleft_top,
                                                    width: this.props.css.f_bottomleft_width,
                                                }}
                                            />
                                            <img
                                                id="f_left"
                                                alt=""
                                                src={this.props.css.f_left_src}
                                                style={{
                                                    left: this.props.css.f_left_left,
                                                    top: this.props.css.f_left_top,
                                                    width: this.props.css.f_left_width,
                                                    height: this.props.css.f_left_height,
                                                }}
                                            />
                                            <img
                                                id="f_top"
                                                alt=""
                                                src={this.props.css.f_top_src}
                                                style={{
                                                    left: this.props.css.f_top_left,
                                                    top: this.props.css.f_top_top,
                                                    width: this.props.css.f_top_width,
                                                    height: this.props.css.f_top_height,
                                                }}
                                            />
                                            <img
                                                id="f_right"
                                                alt=""
                                                src={this.props.css.f_right_src}
                                                style={{
                                                    left: this.props.css.f_right_left,
                                                    top: this.props.css.f_right_top,
                                                    width: this.props.css.f_right_width,
                                                    height: this.props.css.f_right_height,
                                                }}
                                            />
                                            <img
                                                id="f_bottom"
                                                alt=""
                                                src={this.props.css.f_bottom_src}
                                                style={{
                                                    left: this.props.css.f_bottom_left,
                                                    top: this.props.css.f_bottom_top,
                                                    width: this.props.css.f_bottom_width,
                                                    height: this.props.css.f_bottom_height,
                                                }}
                                            />
                                        </div>
                                    )}

                                    {this.props.css.insignia_visible && (
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet={util.webp(this.props.css.insignia_src)}
                                            />
                                            <img
                                                id="insignia"
                                                style={{
                                                    left: this.props.css.insignia_left,
                                                    top: this.props.css.insignia_top,
                                                    width: this.props.css.insignia_width,
                                                    height: this.props.css.insignia_height,
                                                }}
                                                src={this.props.css.insignia_src}
                                                alt=""
                                            />
                                        </picture>
                                    )}

                                    {this.props.css.insignia_bot_visible && (
                                        <img
                                            id="insignia_bot"
                                            style={{
                                                left: this.props.css.insignia_left,
                                                bottom: this.props.css.insignia_bot,
                                                width: this.props.css.insignia_width,
                                                height: this.props.css.insignia_height,
                                            }}
                                            src={this.props.css.insignia_src}
                                            alt=""
                                        />
                                    )}

                                    {this.props.css.lino_visible && (
                                        <picture>
                                            <source
                                                type="image/webp"
                                                srcSet={util.webp(this.props.css.lino_src)}
                                            />
                                            <img
                                                id="lino"
                                                style={{
                                                    left: this.props.css.lino_left,
                                                    top: this.props.css.lino_top,
                                                    width: this.props.css.lino_width,
                                                    height: this.props.css.lino_height,
                                                }}
                                                src={this.props.css.lino_src}
                                                alt=""
                                            />
                                        </picture>
                                    )}

                                    {this.props.css.ep_visible && (
                                        <div
                                            id="ep_bevel"
                                            style={{
                                                backgroundColor: this.props.css.ep_bevel_backgroundColor,
                                                left: this.props.css.ep_bevel_left,
                                                top: this.props.css.ep_bevel_top,
                                                width: this.props.css.ep_bevel_width,
                                                height: this.props.css.ep_bevel_height,
                                            }}
                                        >
                                            <div
                                                id="ep_pmat"
                                                style={{
                                                    backgroundImage: this.props.css.ep_pmat_backgroundImage,
                                                    left: this.props.css.ep_pmat_left,
                                                    top: this.props.css.ep_pmat_top,
                                                    width: this.props.css.ep_pmat_width,
                                                    height: this.props.css.ep_pmat_height,
                                                }}
                                            >
                                                <div
                                                    id="ep"
                                                    style={{
                                                        backgroundImage: this.props.css.ep_backgroundImage,
                                                        backgroundSize: this.props.css.ep_backgroundSize,
                                                        color: this.props.css.ep_color,
                                                        left: this.props.css.ep_left,
                                                        top: this.props.css.ep_top,
                                                        width: this.props.css.ep_width,
                                                        height: this.props.css.ep_height,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <div
                                                        id="ep_lines"
                                                        style={{
                                                            lineHeight: this.props.css.ep_lines_lineHeight,
                                                            fontSize: this.props.css.ep_lines_fontSize,
                                                            width: this.props.css.ep_lines_width,
                                                            height: this.props.css.ep_lines_height,
                                                            whiteSpace: 'nowrap',
                                                            letterSpacing: '-0.1em',
                                                            overflow: 'hidden',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            flexDirection: 'column',
                                                            flexWrap: 'wrap',
                                                        }}
                                                    >
                                                        <div id="ep_line1">{s.pcs.ep1}</div>
                                                        <div id="ep_line2">{s.pcs.ep2}</div>
                                                        <div id="ep_line3">{s.pcs.ep3}</div>
                                                        {/* <div id="ep_line4">{s.pcs.ep4}</div>
                                                        <div id="ep_line5">{s.pcs.ep5}</div>
                                                        <div id="ep_line6">{s.pcs.ep6}</div>
                                                        <div id="ep_line7">{s.pcs.ep7}</div>
                                                        <div id="ep_line8">{s.pcs.ep8}</div>
                                                        <div id="ep_line9">{s.pcs.ep9}</div>
                                                        <div id="ep_line10">{s.pcs.ep10}</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.props.css.varsity_visible && (
                                        <div
                                            id="varsity_pmat_bevel"
                                            style={{
                                                left: this.props.css.varsity_pmat_bevel_left,
                                                top: this.props.css.varsity_pmat_bevel_top,
                                                width: this.props.css.varsity_pmat_bevel_width,
                                                height: this.props.css.varsity_pmat_bevel_height,
                                                backgroundColor: this.props.css.varsity_pmat_bevel_backgroundColor,
                                            }}
                                        >
                                            <div
                                                id="varsity_smat"
                                                style={{
                                                    left: this.props.css.varsity_smat_left,
                                                    top: this.props.css.varsity_smat_top,
                                                    width: this.props.css.varsity_smat_width,
                                                    height: this.props.css.varsity_smat_height,
                                                    backgroundColor: this.props.css.varsity_smat_backgroundColor,
                                                }}
                                            >
                                                <div
                                                    id="varsity_smat_bevel"
                                                    style={{
                                                        left: this.props.css.varsity_smat_bevel_left,
                                                        top: this.props.css.varsity_smat_bevel_top,
                                                        width: this.props.css.varsity_smat_bevel_width,
                                                        height: this.props.css.varsity_smat_bevel_height,
                                                        backgroundColor: this.props.css.varsity_smat_bevel_backgroundColor,
                                                    }}
                                                >
                                                    <div
                                                        id="varsity_bg"
                                                        style={{
                                                            left: this.props.css.varsity_bg_left,
                                                            top: this.props.css.varsity_bg_top,
                                                            width: this.props.css.varsity_bg_width,
                                                            height: this.props.css.varsity_bg_height,
                                                            backgroundColor: this.props.css.varsity_bg_backgroundColor,
                                                        }}
                                                    >
                                                        <img
                                                            id="varsity"
                                                            style={{
                                                                left: this.props.css.varsity_left,
                                                                top: this.props.css.varsity_top,
                                                                width: this.props.css.varsity_width,
                                                                height: this.props.css.varsity_height,
                                                            }}
                                                            src={this.props.css.varsity_src}
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.props.css.oval_visible && (
                                        <div
                                            id="oval_pmat_bevel"
                                            style={{
                                                borderRadius: this.props.css.oval_pmat_bevel_borderRadius,
                                                left: this.props.css.oval_pmat_bevel_left,
                                                top: this.props.css.oval_pmat_bevel_top,
                                                width: this.props.css.oval_pmat_bevel_width,
                                                height: this.props.css.oval_pmat_bevel_height,
                                                backgroundColor: this.props.css.oval_pmat_bevel_backgroundColor,
                                            }}
                                        >
                                            <div
                                                id="oval_smat"
                                                style={{
                                                    borderRadius: this.props.css.oval_smat_borderRadius,
                                                    left: this.props.css.oval_smat_left,
                                                    top: this.props.css.oval_smat_top,
                                                    width: this.props.css.oval_smat_width,
                                                    height: this.props.css.oval_smat_height,
                                                    backgroundColor: this.props.css.oval_smat_backgroundColor,
                                                }}
                                            >
                                                <div
                                                    id="oval_smat_bevel"
                                                    style={{
                                                        borderRadius: this.props.css.oval_smat_bevel_borderRadius,
                                                        left: this.props.css.oval_smat_bevel_left,
                                                        top: this.props.css.oval_smat_bevel_top,
                                                        width: this.props.css.oval_smat_bevel_width,
                                                        height: this.props.css.oval_smat_bevel_height,
                                                        backgroundColor: this.props.css.oval_smat_bevel_backgroundColor,
                                                    }}
                                                >
                                                    <img
                                                        id="oval"
                                                        style={{
                                                            borderRadius: this.props.css.oval_borderRadius,
                                                            left: this.props.css.oval_left,
                                                            top: this.props.css.oval_top,
                                                            width: this.props.css.oval_width,
                                                            height: this.props.css.oval_height,
                                                        }}
                                                        src={this.props.css.oval_src}
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Spirit */}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_lef"
                                            style={{
                                                backgroundColor: '#FFF',
                                                left: this.props.css.spi_left_left,
                                                top: this.props.css.spi_left_top,
                                                width: this.props.css.spi_left_width,
                                                height: this.props.css.spi_left_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_rig"
                                            style={{
                                                backgroundColor: '#FFF',
                                                right: this.props.css.spi_right_right,
                                                top: this.props.css.spi_right_top,
                                                width: this.props.css.spi_right_width,
                                                height: this.props.css.spi_right_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_top_1"
                                            style={{
                                                backgroundColor: '#FFF',
                                                left: this.props.css.spi_top1_left,
                                                top: this.props.css.spi_top1_top,
                                                width: this.props.css.spi_top1_width,
                                                height: this.props.css.spi_top1_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_top_2"
                                            style={{
                                                backgroundColor: '#FFF',
                                                right: this.props.css.spi_top2_right,
                                                top: this.props.css.spi_top2_top,
                                                width: this.props.css.spi_top2_width,
                                                height: this.props.css.spi_top2_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_bot_1"
                                            style={{
                                                backgroundColor: '#FFF',
                                                left: this.props.css.spi_bot1_left,
                                                bottom: this.props.css.spi_bot1_bot,
                                                width: this.props.css.spi_bot1_width,
                                                height: this.props.css.spi_bot1_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_bot_2"
                                            style={{
                                                backgroundColor: '#FFF',
                                                right: this.props.css.spi_bot2_right,
                                                bottom: this.props.css.spi_bot2_bot,
                                                width: this.props.css.spi_bot2_width,
                                                height: this.props.css.spi_bot2_height,
                                            }}
                                        />
                                    )}

                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_lef"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                left: this.props.css.spi_smat_left_left,
                                                top: this.props.css.spi_smat_left_top,
                                                width: this.props.css.spi_smat_left_width,
                                                height: this.props.css.spi_smat_left_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_rig"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                right: this.props.css.spi_smat_right_right,
                                                top: this.props.css.spi_smat_right_top,
                                                width: this.props.css.spi_smat_right_width,
                                                height: this.props.css.spi_smat_right_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_top_1"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                left: this.props.css.spi_smat_top1_left,
                                                top: this.props.css.spi_smat_top1_top,
                                                width: this.props.css.spi_smat_top1_width,
                                                height: this.props.css.spi_smat_top1_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_top_2"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                right: this.props.css.spi_smat_top2_right,
                                                top: this.props.css.spi_smat_top2_top,
                                                width: this.props.css.spi_smat_top2_width,
                                                height: this.props.css.spi_smat_top2_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_bot_1"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                left: this.props.css.spi_smat_bot1_left,
                                                bottom: this.props.css.spi_smat_bot1_bot,
                                                width: this.props.css.spi_smat_bot1_width,
                                                height: this.props.css.spi_smat_bot1_height,
                                            }}
                                        />
                                    )}
                                    {this.props.css.spirit_visible && (
                                        <div
                                            id="spirit_smat_bot_2"
                                            style={{
                                                backgroundColor: this.props.css.spirit_smat_bg,
                                                right: this.props.css.spi_smat_bot2_right,
                                                bottom: this.props.css.spi_smat_bot2_bot,
                                                width: this.props.css.spi_smat_bot2_width,
                                                height: this.props.css.spi_smat_bot2_height,
                                            }}
                                        />
                                    )}

                                    {/* Cameo */}
                                    {this.props.css.cameo_visible && (
                                        <div
                                            id="cameo_pmat_bevel"
                                            style={{
                                                borderRadius: this.props.css.cameo_pmat_bevel_borderRadius,
                                                left: this.props.css.cameo_pmat_bevel_left,
                                                top: this.props.css.cameo_pmat_bevel_top,
                                                width: this.props.css.cameo_pmat_bevel_width,
                                                height: this.props.css.cameo_pmat_bevel_height,
                                                backgroundColor: this.props.css.cameo_pmat_bevel_backgroundColor,
                                            }}
                                        >
                                            <img
                                                id="cameo"
                                                style={{
                                                    borderRadius: this.props.css.cameo_borderRadius,
                                                    left: this.props.css.cameo_left,
                                                    top: this.props.css.cameo_top,
                                                    width: this.props.css.cameo_width,
                                                    height: this.props.css.cameo_height,
                                                }}
                                                src={this.props.css.cameo_src}
                                                alt=""
                                            />
                                        </div>
                                    )}

                                    {s.prod && s.prod.is_tassel_cord && s.PortalID !== 3 && (
                                        <div className="tassel-cord tassel-cord-2">
                                            <picture>
                                                <source
                                                    type="image/webp"
                                                    srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.webp`}
                                                />
                                                <img
                                                    width="128"
                                                    height="128"
                                                    src={`https://${s.Portal.CDNDomain}/images/cached/general/honor-cord1.png`}
                                                    alt="Frame Also Holds Cord"
                                                    loading="lazy"
                                                />
                                            </picture>
                                        </div>
                                    )}
                                </div>
                            )}

                            {replaceImage && newImage}
                        </div>
                    </div>
                );
            }
        };

        const isMobile = window.innerWidth < 1200;
        const zoomContainerVisible = this.isZoomVisible && AbTestStore.ABIsVariant(ABTestKeys.prod_zoom, 1) && !this.props.zoom && !isMobile;
        const content = (
            <>
                <div
                    onMouseMove={this.onMouseMove}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    ref={this.originalContainerRef}
                >
                    {renderContent()}
                    {zoomContainerVisible && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                opacity: 0.5,
                                backgroundColor: 'gray',
                            }}
                            ref={this.zoomSquareContainerRef}
                        ></div>
                    )}
                </div>
                {zoomContainerVisible && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: '105%',
                            zIndex: 100,
                            overflow: 'hidden',
                            background: 'white',
                        }}
                    >
                        <div
                            className="position-absolute"
                            ref={this.zoomedContainerRef}
                        >
                            {renderContent()}
                        </div>
                    </div>
                )}
            </>
        );

        const insigniaVisible = AbTestStore.ABIsVariant(ABTestKeys.prod_zoom, 2) && this.isZoomVisible && s.ui.name_insignia;
        const insignia = (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: `#${s.ui.color_mat1}`,
                    width: `${this.originalContainerRef.current?.getBoundingClientRect().width}px`,
                    height: `${this.originalContainerRef.current?.getBoundingClientRect().height}px`,
                }}
                onMouseLeave={this.onMouseLeave}
            >
                <img
                    src={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${s.ui.name_insignia.toLowerCase()}_original.png`}
                    alt="Insignia"
                    loading="lazy"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                    }}
                />
            </div>
        );

        return (
            <div
                style={{
                    display: 'flex',
                    alignSelf: 'center',
                    position: 'relative',
                }}
            >
                {insigniaVisible ? insignia : content}
            </div>
        );
    }
}
